module.exports = __webpack_public_path__ + "static/media/logo_80_nc.df65f9d1.png";